// extracted by mini-css-extract-plugin
export default {"large":"Geighth_large__07f6I","small":"Geighth_small__kc4mc","Geighth":"Geighth_Geighth__bdVm+","text":"Geighth_text__1JnlA","img":"Geighth_img__1RLFo"};